import { Injectable } from '@angular/core';
import { IAnnualReport } from '@modeso/types__aumico-lib-annualreport-be';
import { cloneDeep } from 'lodash-es';
import { ArFeatureBaseStateServiceAdapter } from '../../../../../_base/arFeatureBaseState.service';
import { ClosingEntryHelper } from '../../domain/helpers/closingEntries.helper';
import { FcpModel } from '../../domain/models/fcp.model';

@Injectable({
    providedIn: 'root',
})
export class FcpStateServiceAdapter extends ArFeatureBaseStateServiceAdapter<FcpModel> {
    getModifiedData(original: IAnnualReport): IAnnualReport {
        const annualReportToSave: IAnnualReport = cloneDeep<IAnnualReport>(original);

        if (this.domainModel == null) {
            return annualReportToSave;
        }

        const dueDates = {
            dueDate: new Date(annualReportToSave.generalInformation.balanceSheetDate),
            dueDatePY: new Date(annualReportToSave.generalInformation.balancePreviousYearDate),
            periodFrom: new Date(annualReportToSave.generalInformation.incomeCurrentYearFromDate),
            periodTo: new Date(annualReportToSave.generalInformation.incomeCurrentYearToDate),
            periodFromPY: annualReportToSave.generalInformation.noPreviousData ? null : new Date(annualReportToSave.generalInformation.incomePreviousYearFromDate),
            periodToPY: annualReportToSave.generalInformation.noPreviousData ? null : new Date(annualReportToSave.generalInformation.incomePreviousYearToDate),
        };
        annualReportToSave.fcp = ClosingEntryHelper.applyAdjustmentsOnInputFinStatements(this.domainModel, dueDates);
        return annualReportToSave;
    }
}
